export default __webpack_public_path__ + "4c65fb5ec9ec60bf34dc9eed5aae4f6c.png";